export default "__VITE_ASSET__euY4Fjto__"